<template>
  <b-row class="justify-content-center">
    <b-col v-if="!contact.username && !contact.password" cols="12" sm="8" md="6">
      <label>Email</label>
      <ValidationProvider
        ref="vee-contact-email"
        v-slot="{ errors, classes }"
        :name="'email'"
        :rules="isEmailRequired ? 'required|email' : 'email'"
      >
        <b-input :value="contact.email" @input="updateContact('email', $event)" />
        <span :class="classes">{{ errors[0] }}</span>
      </ValidationProvider>
    </b-col>
    <b-col v-if="!contact.username && !contact.password" cols="8" class="mt-0 mt-md-4">
      <b-form-checkbox
        :value="1"
        :unchecked-value="0"
        :checked="isEmailRequired"
        class="d-inline text-center"
        switch
        @change="sendCredentials"
      />
      <span>
        <font-awesome-icon icon="info-circle" />
        {{ "Voulez envoyer des informations d'identification à ce contact ?" }}
      </span>
    </b-col>
    <b-col v-if="contact.username || contact.password" cols="12" sm="8" md="4">
      <b-card>
        <div>
          <span>{{ $t("general.Username") }}: </span>
          <strong class="ml-2">{{ contact.username }}</strong>
        </div>
        <hr />
        <div class="d-inline-flex">
          <span>{{ $t("general.Password") }}: </span>
          <strong class="ml-2">
            <appUserPasswordBlock
              :password="contact.password"
              :show-password="showPassword"
              @toggleShowPassword="showPassword = !showPassword"
            />
          </strong>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import appUserPasswordBlock from "@/components/snippets/UserPasswordBlock";
export default {
  components: {
    appUserPasswordBlock,
  },
  props: {
    contact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showPassword: false,
      isEmailRequired: false,
    };
  },
  methods: {
    updateContact(key, value) {
      this.$emit("updateContact", key, value);
    },
    sendCredentials() {
      this.isEmailRequired = !this.isEmailRequired;
    },
  },
};
</script>
